export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-problem-2.d1d043e9.png";